import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import Logger from "@shared/libs/logger";
import {TinyEmitter} from "tiny-emitter";
import { setupVant } from '@/config/vant';
import '../public/assets/iconfont/iconfont.css';
import '@shared/styles/ck-content.css';
import "@/styles/room-v2.less";
import "@/styles/room-goods.less";
import Toast from "@shared/libs/toast";
import ToastEngineVant from "@/common/toast-engine-vant";
import Dialog from "@shared/libs/dialog";
import DialogEngineVant from "@/common/dialog-engine-vant";
import "./main.css";

Toast.setEngine(new ToastEngineVant());
Dialog.setEngine(new DialogEngineVant());

Logger.boot({
    uploadUrl: process.env.VUE_APP_LOG_UPLOAD_URL ? process.env.VUE_APP_LOG_UPLOAD_URL : '',
});

// eslint-disable-next-line
// @ts-ignore
const app = createApp(App);
setupVant(app);

app.use(router).mount('#app')

const $bus = new TinyEmitter();
app.provide('$bus', $bus);
app.config.globalProperties.$bus = $bus;

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $bus: TinyEmitter;
    }
}

